/* eslint-disable no-unused-vars */
import { TextField, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import globalColors from "../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { AppAPIService } from "../../../services/AppAPIService";
import * as auth from "../../../store/ducks/auth.duck";
import FormatDocument from "../../../utils/FormatDocument";
import verifyCpfCnpj from "../../../utils/validators/IsValidCpfCnpj";
import Loading from "../../home/components/Loading";
import { CreatePassword } from "./component/CreatePassword";
import { Container } from "./style";

const useStyles = makeStyles({
  root: {
    "& label": {
      color: globalColors.textColor1,
    },
    "& label.Mui-focused": {
      color: globalColors.textColor1,
    },
    "& input": {
      color: globalColors.textColor1,
      padding: "12px 16px",
      fontSize: "16px",
    },
    "& .MuiOutlinedInput-root": {
      height: "100vh",
      maxHeight: "48px",
      "& fieldset": {
        borderColor: globalColors.textColor2,
      },
      "&.Mui-focused fieldset": {
        border: `1px solid ${globalColors.primaryColor2}`,
      },
    },
  },
  multilineColor: {
    color: globalColors.textColor1,
    fontSize: "16px",
  },
  typography: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
  },
  svg: {
    color: globalColors.primaryColor2,
  },
});

function RecoveryPasssword(props) {
  const classes = useStyles();

  const api = AppAPIService.getInstance();
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [cpfCnpjError, setCpfCnpjError] = useState("");
  const [cpfCnpjRole, setCpfCnpjRole] = useState('')

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const [emailSent, setEmailSent] = useState(false);

  const [disabledButton, setDisabledButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [requestError, setRequestError] = useState("");

  const reloadForm = () => {
    setCpfCnpj("");
    setEmailSent(false);
    setCpfCnpjError("");
    setDisabledButton(false);
    setRequestError("");
  };

  const handleCpfCnpjChange = (e) => {
    const value = e.target.value;

    if (value.length > 18) {
      return;
    }
    if (value.length < 1) {
      setCpfCnpj(value);
      setCpfCnpjError("CPF/CNPJ Obrigatório");
      setCpfCnpjRole("notOk");
      setDisabledButton(false);
    } else if (!verifyCpfCnpj(value).isValid) {
      setCpfCnpj(value);
      setCpfCnpjError("Não é um CPF/CNPJ válido.");
      setCpfCnpjRole("notOk");
      setDisabledButton(false);
    } else {
      setCpfCnpj(FormatDocument(value));
      setCpfCnpjError("");
      setCpfCnpjRole("ok");
    }
  };

  const handleEmailSend = async () => {
    if (cpfCnpjRole !== "ok") return;

    setDisabledButton(true);
    setIsLoading(true);
    setRequestError("");

    try {
      const result = await api.makeHttpRequest({
        url: "/auth/forgot-password",
        method: "POST",
        data: {
          cpfCnpj: cpfCnpj.replace(/[^0-9]/g, ""),
        },
      });
      if (result?.accepted === true) {
        setEmailSent(true);
      } else throw new Error("Resposta inesperada do servidor");
    } catch (e) {
      const payload = e?.response?.data;
      const code = payload?.code || payload?.error?.code;
      setRequestError(
        code === "ACCOUNT_NOT_ACTIVATED" || e?.response?.status === 409
          ? "Seu acesso ainda não foi ativado. Entre em contato com o escritório para receber um novo convite."
          : e?.response?.status === 503
          ? "O serviço de e-mail está temporariamente indisponível. Aguarde alguns minutos e tente novamente."
          : !e?.response
          ? "Não foi possível conectar ao portal. Verifique sua internet e tente novamente."
          : "Não foi possível concluir a solicitação agora. Tente novamente em alguns minutos."
      );
    }

    setDisabledButton(false);
    setIsLoading(false);
  };

  window.setPageTitle("Recovery Passsword");
  return (
    <>
      <Loading isLoading={isLoading} />
      {!isLoading && (
        <div className="kt-login__body">
          <div className="kt-login__form">
            <div
              className="kt-login__title"
              style={{
                color: globalColors.textColor1,
                padding: 0,
              }}
            >
              {!emailSent && !token ? (
                <Container
                  style={{
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <Container
                    style={{
                      textAlign: "left",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      display: "flex",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography
                      variant="h3"
                      style={{
                        color: globalColors.textColor1,
                        margin: 0,
                        fontWeight: "bold",
                        fontSize: "24px",
                      }}
                    >
                      Recuperação de senha
                    </Typography>
                    <Typography
                      variant="p"
                      style={{
                        marginTop: "16px",
                        fontSize: "14px",
                      }}
                    >
                      Digite seu CPF/CNPJ cadastrado.
                    </Typography>
                    <Typography
                      variant="p"
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                      }}
                    >
                      Você receberá um link por e-mail para criar uma nova
                      senha.
                    </Typography>
                  </Container>
                  <TextField
                    label="CPF/CNPJ"
                    name="cpfCnpj"
                    type="text"
                    placeholder="Digite seu CPF/CNPJ"
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    InputProps={{
                      classes: { input: classes.multilineColor },
                    }}
                    sx={{
                      "& label": {
                        fontSize: "16px",
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                    className={clsx(classes.root)}
                    value={cpfCnpj}
                    error={cpfCnpjError !== "" ? true : false}
                    onChange={handleCpfCnpjChange}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") handleEmailSend();
                    }}
                    autoComplete="username"
                    style={{
                      borderColor: cpfCnpjError !== "" ? "red" : "white",
                      marginTop: "32px",
                    }}
                  />
                  <Container
                    maxWidth="xl"
                    style={{
                      height: "34px",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      marginBottom: "5px",
                    }}
                  >
                    {cpfCnpjError !== "" && (
                      <Typography
                        variant="p"
                        style={{
                          fontSize: "12px",
                          color: "red",
                          textAlign: "left",
                        }}
                      >
                        CPF/CNPJ inválido!
                      </Typography>
                    )}
                  </Container>
                  {requestError ? (
                    <div className="xv-auth-feedback xv-auth-feedback--error" role="alert">
                      <strong>Não foi possível enviar o link.</strong>
                      <span>{requestError}</span>
                    </div>
                  ) : null}
                  <Button
                    type="submit"
                    variant="primary"
                    id="kt_login_signin_submit"
                    disabled={disabledButton || !verifyCpfCnpj(cpfCnpj).isValid}
                    onClick={handleEmailSend}
                    className={`btn btn-elevate btn-width kt-login__btn-primary justify-content-end ${clsx(
                      {
                        "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": isLoading,
                      }
                    )}`}
                    style={{
                      width: "100%",
                      height: "50px",
                      backgroundColor: (!verifyCpfCnpj(cpfCnpj).isValid) ? globalColors.backgroundColor2 : globalColors.primaryColor1,
                      border: (cpfCnpj) ? globalColors.backgroundColor2 : globalColors.primaryColor1,
                      fontFamily: "Open Sans",
                      fontSize: "18px",
                      borderRadius: "8px",
                      textTransform: "none",
                      cursor: (!verifyCpfCnpj(cpfCnpj).isValid) ? "not-allowed" : "pointer",
                    }}
                  >
                    <span className="text-light">
                      <b>{disabledButton ? "Enviando..." : "Enviar link de recuperação"}</b>
                    </span>
                  </Button>
                  <button
                    type="button"
                    className="xv-auth-back-link"
                    onClick={() => props.history.push("/auth/login")}
                  >
                    Voltar para o login
                  </button>
                </Container>
              ) : emailSent && !token ? (
                <Container
                  style={{
                    textAlign: "left",
                    display: "block",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <h1
                    style={{
                      color: globalColors.textColor1,
                    }}
                  >
                    Confira seu e-mail
                  </h1>
                  <p>
                    Se o CPF/CNPJ estiver cadastrado e ativo, você receberá um
                    link para redefinir sua senha. Verifique também a caixa de spam.
                  </p>
                  <Button
                    type="submit"
                    variant="primary"
                    onClick={() => {
                      window.location.href = "/auth/login";
                    }}
                    className={`btn btn-elevate btn-width kt-login__btn-primary justify-content-end ${clsx(
                      {
                        "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": isLoading,
                      }
                    )}`}
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  >
                    <span className="text-light">
                      <b>Voltar para o login</b>
                    </span>
                  </Button>
                </Container>
              ) : (
                <CreatePassword
                  code={token}
                  resetAll={reloadForm}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {/* <ActivateAccount
        email={email}
        open={activateModal}
        setOpen={setActivateModal}
      /> */}
    </>
  );
}

const mapActionsToProps = (dispatch) =>
  bindActionCreators(
    {
      login: auth.actions.login,
    },
    dispatch
  );

export default injectIntl(connect(null, mapActionsToProps)(RecoveryPasssword));
